import { css, styled } from '@mui/material'
import { transientOptions } from '../../../styles/TransientOptions'
import { ReactComponent as SvgCurrentlyFlag } from '../../../assets/common/currently-flag.svg'
import { themeValue } from 'styles'

export const NetworkIcon = styled('img')`
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  margin-right: 4px;
  border-radius: 50%;
  overflow: hidden;
`
const cssNetworkItemDisabled = css`
  opacity: 0.3;
  cursor: not-allowed;
`
export const NetworkOption = styled('div', transientOptions)<{
  $disabled?: boolean
}>`
  display: flex;
  align-items: center;
  gap: 4px;
  height: 44px;
  cursor: pointer;
  white-space: nowrap;
  user-select: none;
  padding: 8px 44px 8px 14px;
  position: relative;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: ${({ theme }) => theme.color.text90};

  border-left: 2px solid transparent;
  overflow: hidden;

  &.active {
    border-left: 2px solid ${({ theme }) => theme.color.primary20};
    background-color: ${themeValue(
      'rgba(42, 49, 57, 1)',
      'rgba(242, 243, 245, 1)',
    )};
  }

  ${({ $disabled }) => $disabled && cssNetworkItemDisabled}

  &:hover {
    background-color: ${themeValue(
      'rgba(42, 49, 57, 1)',
      'rgba(242, 243, 245, 1)',
    )};
  }
`
export const CurrentChainFlag = styled(SvgCurrentlyFlag)`
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
`
export const NetworkPopupList = styled('div')`
  display: inline-flex;
  flex-direction: column;
  background-color: ${themeValue(
    'rgba(30, 35, 41, 1)',
    'rgba(255, 255, 255, 1)',
  )};
  border-radius: 6px;
  border-radius: 0px 0px 4px 4px;
  box-shadow: 0 1px 2px rgb(0 0 0 / 5%);
  overflow: hidden;
  padding: 18px 0px;

  ${({ theme }) => theme.breakpoints.down('md')} {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 0;
    background-color: rgba(22, 25, 30, 1);
  }
`
